import { render, staticRenderFns } from "./pie-chart.vue?vue&type=template&id=0ec3dc9a&"
import script from "./pie-chart.vue?vue&type=script&lang=js&"
export * from "./pie-chart.vue?vue&type=script&lang=js&"
import style0 from "./pie-chart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\projects\\tesas_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0ec3dc9a', component.options)
    } else {
      api.reload('0ec3dc9a', component.options)
    }
    module.hot.accept("./pie-chart.vue?vue&type=template&id=0ec3dc9a&", function () {
      api.rerender('0ec3dc9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/pie-chart.vue"
export default component.exports